module.exports = __webpack_public_path__ + "img/co2.62c50837.svg";